import ListReportTypeStore from './reportType.list';
import DetailReportTypeStore from './reportType.details';
export const reportTypeStores = {
    list: ListReportTypeStore,
    detail: DetailReportTypeStore
}